/*** IMPORTS FROM imports-loader ***/
var define = false;

// Having this as a module allows us to retrieve a list of all registered filter classes from several different modules.
let filterClasses = [];

function registerFilterClass(filterClass = 'filtered') {
  if (!filterClasses.includes(filterClass)) {
    filterClasses.push(filterClass);
  }
  return filterClass;
}

export function addFilterClass(el, className) {
  className = registerFilterClass(className);
  el.classList.add(className);
}

export function removeFilterClass(el, className) {
  className = registerFilterClass(className);
  el.classList.remove(className);
}

export function hasFilterClass(el) {
  return filterClasses.some((className) => el.classList.contains(className));
}

